module.exports = __webpack_public_path__ + "media/images/athletes/1547-765f8fcaecd52ac7d1a5bb6d86807b4f.png";